import { baseApi } from "@dex/bubl-fetch";

const endpoint = 'WatchTag';

const WatchTagApi: any = baseApi(endpoint);

export default WatchTagApi;